// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsCollectionsTemplate_heading__z2p9d"};